// src/pages/Home.js
import React, { useEffect } from "react";
import SlideShow from "../components/SlideShow";
import "./Home.css";
import PopupPictureDisplay from "../components/PopupPictureDisplay";
import disneyLogo from "../assets/Disney_ICP logo.png";
import canadaLogo from "../assets/Logo_Canada Program1.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Home = () => {
  useEffect(() => {
    // Your existing visitor count logic here (if still needed)
  }, []);

  return (
    <div className="home">
      {/* Display the popup if an image exists on the server */}
      <PopupPictureDisplay />
      <SlideShow />
      <Helmet>
        <title>Home | Londonhouse </title>
      </Helmet>
      <header>
        <h1>LONDON HOUSE</h1>
      </header>
      <section className="introduction"> 
        <div className="introduction-text1"> 
            <p>
              London House School of English, Chiang Mai was founded in 2001.<br />
              We are proud to be one of the oldest language schools in the city and have been providing English language instruction in Chiang Mai<br />
               for over fifteen years. Our English School is based in northern Thailand in the picturesque mountainside town of Chiang Mai.
            </p> 
          </div> 
          <div className="introduction-text2"> 
            <p>London House is committed to maintaining and improving standards of teaching and learning both in and out of the classroom. <br />
            Our enthusiastic and dedicated English language teachers are committed<br />
             to helping each student feel confident in using English in communication. <br />
             We believe that the key for good communicators is all about having confidence – Confidence is all it takes.
            </p> 
          </div> 
        </section>
      <section className="programs" id="programs">
        <div className="programsHead">
          <h2 id="PROGRAMS">PROGRAMS</h2>
        </div>
        <div className="underline2">
          <div className="underline"></div>
        </div>
        <div className="program-paragraph">
          <p>
            Get new experiences of languages and cultures across the world with{" "}
            <br />
            Walt Disney World Company and Tamwood International College.
          </p>
        </div>
        <div className="button-container flex">
          <div className="disneyButton">
            <div className="disneyButtonShape">
              <Link to="/disney">
                <img src={disneyLogo} alt="Disney Program Button" />
              </Link>
            </div>
          </div>
          <div className="canadaButton">
            <div className="canadaButtonShape">
              <Link to="/tamwood">
                <img src={canadaLogo} alt="Canada Program Button" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
